<template>
  <div>
    <b-card
      no-body
    >
      <b-card-header>
        <h4 class="mb-0">
          {{ region }}
        </h4>

        <b-form-checkbox
          v-model="hideFreezers"
          value="hideFreezers"
          class="custom-control-primary"
          @input="filterHideFreezers"
        >
          Hide freezers with no door activity since restock
        </b-form-checkbox>

        <b-card-text class="font-medium-5 mb-0">
          <b-button
            variant="outline-primary"
            @click="drivingRoute"
          >
            Driving Route
          </b-button>
        </b-card-text>

      </b-card-header>

      <div
        v-if="dataDone === true"
      >
        <b-table
          :items="items"
          :fields="fields"
          striped
          hover
          responsive
          sort-by="level"
          @row-clicked="onRowClick"
        >

          <template #cell(drivingRoute)="data">
            <b-form-checkbox
              v-model="selected"
              :value="data.item"
              plain
            />
          </template>

          <template #cell(level)="data">
            <b-badge
              :variant="levelColor(data)"
            >
              {{ `${data.item.level} %` }}
            </b-badge>
          </template>

          <template #cell(restockedDate)="data">

            <b-badge
              v-if="data.item.restocked !== undefined"
              variant="primary"
            >
              {{ new Date(`${data.item.restocked.time} UTC`).toLocaleString() }}
            </b-badge>
          </template>

          <template #cell(restockedBy)="data">
            <b-badge
              v-if="data.item.restocked !== undefined"
              variant="primary"
            >
              {{ data.item.restocked.restockedBy }}
            </b-badge>
          </template>

          <template #cell(lastEvent)="data">
            <b-badge
              variant="primary"
            >
              {{ data.item.lastEvent }}
            </b-badge>
          </template>

          <template #cell(restock)="data">
            <b-button
              variant="outline-primary"
              @click="restock(data.item)"
            >Restock</b-button>
          </template>
        </b-table>
      </div>

      <div
        v-if="dataDone === false "
        class="mt-2 mb-4 text-center"
      >
        <b-row class="justify-content-md-center">
          <b-col
            lg="3"
          >
            <b-progress
              v-model="items.length"
              :max="sites.length"
              striped
            />
          </b-col>
        </b-row>
      </div>

    </b-card>
  </div>
</template>

<script>
/* eslint-disable dot-notation */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-unused-vars */
import {
  BTable,
  BCard,
  BCardHeader,
  BCardText,
  BButton,
  BBadge,
  // BSpinner,
  BFormCheckbox,
  BProgress,
  BCol,
  BRow,

} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import * as queries from '../../../graphql/queries'

export default {
  components: {
    BCol,
    BTable,
    BCard,
    BCardHeader,
    BCardText,
    BButton,
    BBadge,
    // BSpinner,
    BFormCheckbox,
    BProgress,
    BRow,

  },
  props: {
    region: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filter: null,
      filterOn: [],
      hideFreezers: ['hideFreezers'],
      dataDone: false,
      workspacetoken: '',
      workspace: JSON.parse(localStorage.getItem('userData')).currentWorkspace.id,
      fields: [
        { key: 'drivingRoute', label: 'Add To Driving Route' },
        { key: 'name', label: 'Site name' },
        { key: 'level', label: 'level', sortable: true },
        { key: 'restockedDate', label: 'Restock Date' },
        { key: 'restockedBy', label: 'Restocked By' },
        { key: 'lastEvent', label: 'Last Door Opening' },
        { key: 'restock', label: 'Restock' },

      ],
      sites: [],
      items: [],
      nonFilteredItems: [],
      filteredItems: [],
      selected: [],
      apiName: 'TimestreamAPI',
      path: '/items',
    }
  },
  created() {
    this.init()
  },
  methods: {
    filterHideFreezers() {
      if (this.hideFreezers.length > 0) {
        this.items = this.filteredItems
      } else if (this.hideFreezers.length === 0) {
        this.items = this.nonFilteredItems
      }
    },
    onRowClick(event) {
      window.location.href = `/site/${event.id}`
    },
    drivingRoute() {

    },
    levelColor(data) {
      if (data.item.level >= 75) {
        return 'success'
      }
      if (data.item.level >= 50 && data.item.level <= 75) {
        return 'warning'
      }
      if (data.item.level >= 0 && data.item.level <= 50) {
        return 'danger'
      }
      return 'primary'
    },
    async init() {
      const workspace = JSON.parse(localStorage.getItem('userData')).currentWorkspace.id
      const getWorkspaceResponse = await API.graphql({
        query: queries.getWorkspace,
        variables: {
          id: workspace,
        },
      })
      this.workspacetoken = getWorkspaceResponse.data.getWorkspace.workspacetoken
      this.sites = await this.listSites()
      const done = await this.iterateSites()
      this.nonFilteredItems = this.items
      this.filteredItems = this.items.filter(item => item.lastEvent !== undefined)
      this.items = this.filteredItems
      this.dataDone = done
    },
    async restock(site) {
      this.dataDone = false
      const workspace = JSON.parse(localStorage.getItem('userData')).currentWorkspace.id
      const userName = JSON.parse(localStorage.getItem('userData')).attributes.email
      const table = 'restocks'
      const apiName = 'TimestreamAPI'
      const path = '/items'
      const myInit = {
        headers: {
          workspace,
          workspacetoken: this.workspacetoken,
          'Content-Type': 'application/json',
        },
        body: {
          table,
          id: site.objects.items[0].id,
          timestamp: Date.now(),
          records: [
            {
              MeasureName: 'restock',
              MeasureValue: '100',
              MeasureValueType: 'DOUBLE',
            },
            {
              MeasureName: 'restockedBy',
              MeasureValue: userName,
              MeasureValueType: 'VARCHAR',
            }],
        },
      }

      const restock = await API.post(apiName, path, myInit)
      this.items = []
      this.init()
    },
    async getRestock(site) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
        const table = 'restocks'
        const query = `SELECT measure_value::varchar as restockedBy, time FROM "${this.workspace}"."${table}" where id = '${site.objects.items[0].id}' and measure_name = 'restockedBy' ORDER BY time DESC LIMIT 1`
        const myInit = {
          headers: {
            workspace: this.workspace,
            workspacetoken: this.workspacetoken,
          },
          queryStringParameters: {
            query,
          },
        }
        const timestreamResponseRestock = await API.get(this.apiName, this.path, myInit)
        const restocked = timestreamResponseRestock.timestreamData[0][0]
        resolve(restocked)
      })
    },
    async getLastEvent(site, restocked) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
      // Get Last Event since restock
        const queryLastEvent = `SELECT measure_value::double AS doorCount, time
                              FROM "${this.workspace}"."${site.objects.items[0].devices.items[0].deviceModelDevicesId}"
                              WHERE id = '${site.objects.items[0].devices.items[0].id}'
                              and measure_name = 'doorCount'
                              and measure_value::double > 0.0
                              and time between '${restocked.time}' and now()
                              ORDER BY time DESC LIMIT 1`
        const myInit3 = {
          headers: {
            workspace: this.workspace,
            workspacetoken: this.workspacetoken,
          },
          queryStringParameters: {
            query: queryLastEvent,
          },
        }
        const timestreamResponeLastEvent = await API.get(this.apiName, this.path, myInit3)
        const lastEvent = timestreamResponeLastEvent.timestreamData[0][0]
        resolve(lastEvent)
      })
    },
    async getDoorCounts(site, restocked) {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
      // Get Door counts from restock to calculate level
        const queryDoorCounts = `SELECT SUM(measure_value::double) AS doorCounts FROM "${this.workspace}"."${site.objects.items[0].devices.items[0].deviceModelDevicesId}" where id = '${site.objects.items[0].devices.items[0].id}' and measure_name = 'doorCount' and time between '${restocked.time}' and now() `
        const myInit = {
          headers: {
            workspace: this.workspace,
            workspacetoken: this.workspacetoken,
          },
          queryStringParameters: {
            query: queryDoorCounts,
          },
        }
        const timestreamResponseDoorCounts = await API.get(this.apiName, this.path, myInit)
        const { doorCounts } = timestreamResponseDoorCounts.timestreamData[0][0]
        resolve(doorCounts)
      })
    },
    async iterateSites() {
      await Promise.all(
        this.sites.map(async site => {
          if (site.objects.items.length > 0) {
            const item = site
            // Get Restock
            const restock = await this.getRestock(site)
            item.restocked = restock
            if (restock !== undefined) {
              const lastEvent = await this.getLastEvent(site, restock)
              if (lastEvent !== undefined) {
                item.lastEvent = new Date(lastEvent.time).toLocaleString()
              } else {
                item['_rowVariant'] = 'secondary'
              }
              // Get DoorCounts and calculate level
              const doorCounts = await this.getDoorCounts(site, restock)
              if (doorCounts !== undefined) {
                const iceCreams = JSON.parse(site.objects.items[0].properties).filter(property => property.name === 'Ice Creams')
                item.level = Math.round(100 - ((doorCounts / iceCreams[0].value) * 100))
              } else {
                item.level = 100
              }
            } else {
              item['_rowVariant'] = 'secondary'
              item.level = 100
            }
            // Get LastEvent
            this.items.push(item)
          }
        }),
      )
      return true
    },
    async listSites() {
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async resolve => {
        const workspace = JSON.parse(localStorage.getItem('userData')).currentWorkspace.id
        const listSites = await API.graphql({
          query: `
  query ListSites(
    $filter: ModelSiteFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSites(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        name
        workspace
        contact {
          workspace
          firstName
          lastName
          email
          phone
          id
          createdAt
          updatedAt
        }
        objects {
          items {
            id
            name
            properties
            devices {
              items {
                id
                deviceModelDevicesId
                name
              }
            }
          }
          nextToken
        }
        devices {
          nextToken
        }
        metadata
        address
        zip_code
        city
        subRegion
        region
        country
        AWSLocationLabel
        AWSLongLat
        id
        createdAt
        updatedAt
        contactSitesId
      }
      nextToken
    }
  }
`,
          variables: {
            filter: { workspace: { eq: workspace }, region: { eq: this.region } },
          },
        })
        resolve(listSites.data.listSites.items)
      })
    },
  },
}
</script>

<style>

</style>
